// src/components/SupportDialog.jsx
// Support (3.37.0): the Crazy Pixels support site, shown inside the portal
// so people don't leave it. The site is on the same crazypixels.org domain,
// so its sign-in works inside the frame.
// 3.65.0 (owner): it opens signed in. The backend gives a one-time pass
// (POST /portal/support/sso, 60 seconds) that the site's Crazy Pixels portal
// sign-in plugin accepts; the support account is created the first time.
// View as gets the plain sign-in page. 3.65.1 (owner): Super Admins are
// signed in too, so "Open in a new tab" (for Google's sign-in, which won't
// run inside a window) is gone.
import { useEffect, useState } from 'react';
import MenuDialog, { MD } from './MenuDialog';
import { useAuth } from '../hooks/useAuth';
import { API_BASE } from '../firebase/config';

export const SUPPORT_URL = 'https://support.crazypixels.org/ticket/#/login';

// A fresh signed-in link for Support (a pass works once), or the plain page
async function supportLink(getToken) {
  try {
    const r = await fetch(`${API_BASE}/portal/support/sso`, { method: 'POST', headers: { Authorization: `Bearer ${await getToken()}` } });
    const j = await r.json();
    return (r.ok && j.url) || SUPPORT_URL;
  } catch { return SUPPORT_URL; }
}

export default function SupportDialog({ onClose }) {
  const { getToken } = useAuth();
  const [src, setSrc] = useState(null);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { let gone = false; supportLink(getToken).then(u => { if (!gone) setSrc(u); }); return () => { gone = true; }; }, [getToken]);
  return (
    <MenuDialog id="support" icon="🛟" title="Support" onClose={onClose} width={1100} height="88vh"
      sub={`Ask Fax Portal support for help, or check on a request you've made.${src && src !== SUPPORT_URL ? ' Your portal account signs you in.' : ''}`}
      bodyStyle={{ padding: 0, overflow: 'hidden', position: 'relative' }}>
      {/* 3.78.1 (owner, Nov 3): allow="microphone" lets the support chat's voice
          button ask for the microphone; without it the browser refused silently
          inside this window (the support site's own chat frame already allows it) */}
      {src && <iframe title="Fax Portal support" src={src} onLoad={() => setLoaded(true)} allow="microphone"
        style={{ border: 'none', width: '100%', height: '100%', display: 'block', borderRadius: '0 0 14px 14px' }} />}
      {/* Over the frame (it paints white while it loads) */}
      {!loaded && <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--c-ffffff)', borderRadius: '0 0 14px 14px', ...MD.muted }}>Opening the support site…</div>}
    </MenuDialog>
  );
}
